import { Form, FormInstance, Input } from "antd";
import CountryCodeSelect from "../../FormComponents/CountryCodeSelect";

type StepOneProps = {
  form: FormInstance;
};
export const StepOne: React.FC<StepOneProps> = ({ form }) => {
  return (
    <>
      <Form.Item
        name="name"
        label="Site Name"
        rules={[{ required: true, message: "Please enter a site name!" }]}
      >
        <Input placeholder="Enter site name" />
      </Form.Item>
      <Form.Item
        name="site_id"
        label="Site ID"
        rules={[{ required: true, message: "Please enter a site identifier!" }]}
      >
        <Input placeholder="Enter Site identifier" />
      </Form.Item>
      <Form.Item
        name="coordinates"
        label="Location (Latitude, Longitude)"
        rules={[
          {
            required: true,
            message:
              "Please enter the location, use a service like: https://www.latlong.net/convert-address-to-lat-long.html to convert an address!",
          },
          {
            pattern: /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/,
            message: "Please enter valid coordinates (e.g., 12.34,56.78)",
          },
        ]}
      >
        <Input placeholder="Enter longitude, latitude" />
      </Form.Item>
      <Form.Item
        name="country"
        label="Country (BE, FR,...) 🌎"
        rules={[
          {
            required: true,
            message:
              "Please enter the location, use a service like: https://www.latlong.net/convert-address-to-lat-long.html to convert an address!",
          },
        ]}
      >
        <CountryCodeSelect
          name="country"
          onSelect={(value) => form.setFieldValue("country", value)}
        />
      </Form.Item>
    </>
  );
};
